/* node_modules */
import React, { Fragment, useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { NavLink, RouterProps, generatePath } from 'react-router';
import axios from 'axios';

/* local imports */
import { isLoading } from '~/modules/loading';
import { getVisibilitySettings } from '~/modules/contentVisibility';
import {
  fetchSearch,
  getResultsByType,
  LOADING_RESULTS,
} from '~/modules/search';

import Loading from '~/components/Loading';
import AdultToggle from '~/components/AdultToggle';
import ImageSet from '~/components/Gallery/ImageSet';
import StreamList from '~/components/Stream/List';
import { withRouter } from '~/hooks';

/* style imports */
import styles from './Search.scss';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import Config from '~/config';
import Pagination from '~/components/Pagination';

/**
 * Searchbox component (the one you put strings in)
 */
function SearchBox({ onSubmit, initialQuery = '' }) {
  const [value, setValue] = useState(initialQuery);
  return (
    <form 
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(value);
      }}
      className={styles.SearchBox}
    >
      <input autoFocus value={value} onChange={e => setValue(e.target.value)} placeholder="Search"type="text" />
    </form>
  );
}

/**
 * The search view
 */
function Search({
  navigate,
  location: {
    pathname,
  },
  params,
  path,
}: {
  navigate: Function,
  location: {
    pathname: string,
  },
  params: {
    query: string,
    category: string,
  },
  path: any
}) {
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const adultToggleState = useSelector(getVisibilitySettings);
  const authHeaders = useSelector((state: RootState) => state.auth);
  const { data, isLoading, error } = useQuery({
    queryKey: ['search', params, page],
    queryFn: () => {
      return axios.get<{
        data: GalleryImage[] | Stream[],
        meta: PaginationMeta,
      }>(`${Config.api}/search/${params.category}`, { 
        headers: authHeaders,
        params: {
          page,
          q: params.query,
        } 
      }).then(res => res.data);
    }
  });

  useEffect(() => {
    setPage(1);
  }, [params.query, params.category]);

  const handleSubmit = (query) => {
    if (!query || query === '') return navigate(generatePath(path, { ...params, query: null }));

    return navigate(generatePath(path, { ...params, query }));
  };

  const showResults = () => {
    console.log(data);
    return (
      <Fragment>
        {
          params.category === 'gallery' && 
          <ImageSet images={data?.data || []} adultToggleState={adultToggleState} />
        }
        {
          params.category === 'streams' &&
          <StreamList items={data?.data || []} adultToggleState={adultToggleState} />
        }
      </Fragment>
    );
  };

  return (
    <div>
      <SearchBox initialQuery={params.query} onSubmit={handleSubmit} />
      <div className={styles.Search__SectionPicker}>
        <NavLink
          to={generatePath(path, { ...params, category: 'streams' })}
          className={() => pathname?.includes('streams') ? `${styles.Search__SectionPickerOptionActive} ${styles.Search__SectionPickerOption}` : styles.Search__SectionPickerOption} 
        >
          <i className="ion-ios-film" />
          {' '}
          Streams
        </NavLink>
        <NavLink
          to={generatePath(path, { ...params, category: 'gallery' })}
          className={() => pathname?.includes('gallery') ? `${styles.Search__SectionPickerOptionActive} ${styles.Search__SectionPickerOption}`: styles.Search__SectionPickerOption }
        >
          <i className="ion-images" />
          {' '}
          Gallery
        </NavLink>
      </div>
      <h3>{params.query ? `Showing results for "${params.query}"` : 'Type something to search.'}</h3>

      <AdultToggle />

      <div>
        <Pagination
          page={page}
          onChange={setPage}
          totalPages={data?.meta.total_pages || 0}
        />
      </div>
      {isLoading ? <Loading message="Loading results..." /> : showResults()}
      <div>
        <Pagination
          page={page}
          onChange={setPage}
          totalPages={data?.meta.total_pages || 0}
        />
      </div>
    </div>
  );
}


export default withRouter(Search);
